import { useEffect, useRef } from 'react';
import { useStore } from 'react-redux';

import { logKeraVoiceAssistantSessionEnd } from '../../bi';
import { CARA_RETURN_REFERRAL } from '../../pages/Home/utils/cara';
import { renderModel } from '../../util/renderModel';
import { TRootState } from '../reducers';

/**
 * Detects a return from Cara via URL params (`referral=cara&kera_session_id=<id>`)
 * and fires BI event 4:102 (kera voice assistant session end) once per mount.
 */
export const useFireCaraReturnBi = () => {
  const store = useStore<TRootState>();
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) {
      return;
    }
    const queryParams = renderModel.getQueryParams() ?? {};
    const { referral, kera_session_id } = queryParams as {
      referral?: string;
      kera_session_id?: string;
    };

    if (referral !== CARA_RETURN_REFERRAL || !kera_session_id) {
      return;
    }
    firedRef.current = true;
    logKeraVoiceAssistantSessionEnd(store.getState(), { keraSessionId: kera_session_id });
  }, [store]);
};
